// frontend/src/design-system/components/MeshBackground.tsx
import * as React from 'react';

/**
 * Mesh background — sits behind every page. The page surfaces ride on top of it.
 * Uses CSS radial gradients via the `.bg-mesh` utility defined in index.css.
 * Fixed-position so it doesn't scroll.
 */
export function MeshBackground() {
  return <div aria-hidden className="pointer-events-none fixed inset-0 -z-10 bg-background bg-mesh" />;
}
